import { ROLE_CODES } from "Services/constants";
import {
	ApiUserInfo,
	AmericanAirlinesInfo,
	ChileCompraInfo,
	DiscountClubInfo,
	PeruCompraInfo,
	Cug2Info,
} from "Shared/models/ApiUserInfo";
import { MappedUserInfo } from "Shared/models/MappedUserInfo";

export const mapUserInfo = (apiUserInfo: ApiUserInfo): MappedUserInfo => ({
	AmericanAirlines:
		apiUserInfo.type === "AmericanAirlinesInfo"
			? {
					AdvantageNumber: (apiUserInfo as AmericanAirlinesInfo).advantageNumber,
					EligibleForRedemption: true,
					IsMember: true,
					Miles: (apiUserInfo as AmericanAirlinesInfo).miles,
					Tier: (apiUserInfo as AmericanAirlinesInfo).tier,
					TokenValidTo: (apiUserInfo as AmericanAirlinesInfo).tokenValidTo,
				}
			: undefined,
	Cug2:
		apiUserInfo.type === "Cug2Info"
			? {
					IsAgency: (apiUserInfo as Cug2Info).isAgency,
					IsCompany: (apiUserInfo as Cug2Info).isCompany,
				}
			: undefined,
	ChileCompra:
		apiUserInfo.type === "ChileCompraInfo"
			? {
					IsMember: (apiUserInfo as ChileCompraInfo).isMember,
				}
			: undefined,
	Dc:
		apiUserInfo.type === "DiscountClubInfo"
			? {
					IsGroupMember: (apiUserInfo as DiscountClubInfo).isGroupMember,
					IsStandardMember: (apiUserInfo as DiscountClubInfo).isStandardMember,
				}
			: undefined,
	Membership: apiUserInfo.type === "MembershipInfo",
	PeruCompra:
		apiUserInfo.type === "PeruCompraInfo"
			? {
					Amount: (apiUserInfo as PeruCompraInfo).formattedAmount,
					IsAdmin: (apiUserInfo as PeruCompraInfo).isAdmin,
					IsMember: (apiUserInfo as PeruCompraInfo).isMember,
				}
			: undefined,
	Name: apiUserInfo.name ? { FirstName: apiUserInfo.name.firstName, LastName: apiUserInfo.name.lastName } : undefined,
	OrganizationName: apiUserInfo.organizationName,
	ProgramCodesWithLevels: apiUserInfo.programCodesWithLevels?.map((pwl) => ({
		ProgramCode: pwl.programCode,
		ProgramLevel: pwl.programLevel,
	})),
	RoleCode: apiUserInfo.roleCode || ROLE_CODES.WEB_ANONYMOUS,
});
